import axiosInstance from './axiosInstance';

// Create a new SendGrid subuser
export const createSubuser = (companyId, data = {}) => {
	const url = `/sendgrid/subusers/${companyId}`;
	return axiosInstance.post(url, data);
};

// Get all subusers for the company
export const getSubusers = (companyId) => {
	const url = `/sendgrid/subusers/${companyId}/stats`;
	return axiosInstance.get(url);
};

// Update subuser limits based on subscription
export const updateSubuserLimits = (companyId, data = {}) =>
	axiosInstance.put(`/sendgrid/subusers/${companyId}/limits`, data);

// Get company's email usage stats (same as getSubusers for now)
export const getEmailUsage = (companyId) =>
	axiosInstance.get(`/sendgrid/subusers/${companyId}/stats`);

// Check if company can send emails (within limits)
export const checkEmailLimit = (companyId) =>
	axiosInstance.get(`/sendgrid/subusers/${companyId}/check-limit`);

// Toggle subuser status
export const toggleSubuserStatus = (companyId, data) =>
	axiosInstance.put(`/sendgrid/subusers/${companyId}/status`, data);

// Retry activation of a pending subuser
export const retryActivation = (companyId) =>
	axiosInstance.post(`/sendgrid/subusers/${companyId}/retry-activation`);

// Get all SendGrid subusers (system admin)
export const getAllAdminSubusers = () =>
	axiosInstance.get('/sendgrid/admin/subusers');

// Parent SendGrid account credits (system admin)
export const getSendGridAccountCredits = () =>
	axiosInstance.get('/sendgrid/admin/account-credits');

// Per-subuser SendGrid usage report (system admin)
export const getSendGridSubuserUsageReport = (refresh = false) =>
	axiosInstance.get('/sendgrid/admin/subuser-usage', {
		params: refresh ? { refresh: 'true' } : undefined,
	});

export const getSendGridUsageProjection = (refresh = false) =>
	axiosInstance.get('/sendgrid/admin/usage-projection', {
		params: refresh ? { refresh: 'true' } : undefined,
	});
